import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cargo',
  templateUrl: './cargo.component.html',
  styleUrls: ['./cargo.component.scss'],
  standalone: false
})
export class CargoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
